/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsViewSessionPublicService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const createViewSessionRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsViewSessionPublicService',
  rpcName: 'createViewSession',
  auth: 'external',
  fingerprint: 'onWXG0x3ZAskBX-kiRNVGJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const nextPageRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsViewSessionPublicService',
  rpcName: 'nextPage',
  auth: 'external',
  fingerprint: 'iFrkM7GMJtaOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const finishPageRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsViewSessionPublicService',
  rpcName: 'finishPage',
  auth: 'external',
  fingerprint: 'jjnsBv-HjFuOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const downloadRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsViewSessionPublicService',
  rpcName: 'download',
  auth: 'external',
  fingerprint: 'vZMewvbopeiJfDg5qJEAApwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};